import {render} from "react-dom";

import PageCadastro from '../_pages/PageCadastro';
import ErrorBoundary from "../_lib/components/ErrorBoundary";
import {ToastContainer} from "react-toastify";

(async () => {
    render(
        <ErrorBoundary>
            <PageCadastro/>
            <ToastContainer/>
        </ErrorBoundary>,
        document.getElementById('component-container'));
})();